export default (props) => (
  <svg
    width="192"
    height="45"
    viewBox="0 0 192 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    {...props}
  >
    <g clipPath="url(#clip0_3808_16269)">
      <path
        d="M191.978 11V35.031H135.716V11H191.978ZM139.339 31.6349H188.301V14.4984H139.339V31.6349Z"
        fill="#1D1F21"
      />
      <path
        d="M115.657 16.1835C118.255 16.2819 120.812 16.1638 123.298 16.526C126.495 16.9918 127.782 20.859 125.68 23.2485C125.272 23.7118 124.713 24.0424 124.179 24.4702C125.087 25.7995 126.026 27.1774 127.018 28.63H123.016C122.218 27.4424 121.395 26.2168 120.569 24.9846H119.1V28.6379H115.656V16.1835H115.657ZM119.12 22.2329C119.712 22.2329 120.253 22.2499 120.793 22.2276C121.246 22.2092 121.712 22.2014 122.146 22.0885C122.839 21.9074 123.18 21.3747 123.153 20.6766C123.126 20.0178 122.697 19.4444 121.998 19.3866C121.056 19.3092 120.102 19.3669 119.121 19.3669V22.2329H119.12Z"
        fill="#1D1F21"
      />
      <path
        d="M68.6026 16.3225C69.3532 16.3225 70.0487 16.3199 70.7429 16.3225C72.2283 16.329 73.7138 16.2975 75.1966 16.3566C76.4183 16.4051 77.5639 16.7411 78.4706 17.6373C80.3235 19.4692 79.8865 22.8246 77.6216 24.1172C77.4707 24.2038 77.3172 24.2825 77.0862 24.4085C78.0429 25.8152 78.9877 27.2048 79.985 28.6693H75.9853C75.1861 27.4791 74.362 26.2509 73.5274 25.0095H72.0459V28.6588H68.6013V16.3225H68.6026ZM72.0551 22.2551C72.643 22.2551 73.1626 22.2682 73.681 22.2512C74.135 22.2354 74.6009 22.2393 75.0378 22.137C75.7661 21.9651 76.0942 21.4927 76.0929 20.7736C76.0929 20.0558 75.7609 19.5755 75.0247 19.4233C74.0471 19.2225 73.0564 19.3551 72.0551 19.338V22.2551Z"
        fill="#1D1F21"
      />
      <path
        d="M20.379 16.0154C23.8276 16.0114 26.477 18.1504 27.0688 21.3325C27.7052 24.7548 25.3931 28.1457 21.9524 28.7624C19.1534 29.2637 16.7179 28.5748 14.9857 26.2219C13.5567 24.2798 13.3664 22.0976 14.327 19.9022C15.3138 17.6452 17.1431 16.4221 19.572 16.081C19.8738 16.039 20.1809 16.0311 20.379 16.0154ZM23.6137 22.5293C23.6216 20.599 22.2805 19.1634 20.4656 19.1582C18.6915 19.1529 17.3543 20.5439 17.3412 22.4073C17.3281 24.3152 18.7059 25.7915 20.4971 25.7863C22.27 25.781 23.6071 24.3848 23.615 22.5293H23.6137Z"
        fill="#1D1F21"
      />
      <path
        d="M106.542 16.035C110.381 16.0835 113.244 18.9219 113.186 22.6605C113.136 25.8518 110.604 28.5944 107.419 28.9093C104.903 29.1587 102.73 28.4802 101.131 26.4555C98.1925 22.7392 100.314 17.1412 104.989 16.2292C105.5 16.1295 106.024 16.098 106.542 16.035ZM106.469 19.2027C104.712 19.2054 103.364 20.6186 103.351 22.4715C103.338 24.3638 104.738 25.8413 106.532 25.8308C108.299 25.819 109.638 24.4136 109.644 22.5634C109.651 20.6619 108.269 19.2001 106.468 19.2027H106.469Z"
        fill="#1D1F21"
      />
      <path
        d="M0 28.6627V16.3631C0.132536 16.3474 0.236203 16.3237 0.339869 16.3251C2.06415 16.3303 3.79105 16.2844 5.51271 16.3605C7.23305 16.4353 8.78411 16.9982 10.074 18.2147C12.5187 20.519 12.5319 26.1366 8.24347 28.0105C7.22911 28.4541 6.16882 28.6863 5.07179 28.706C3.52204 28.7336 1.97229 28.7139 0.421228 28.7112C0.293941 28.7112 0.165342 28.6824 0 28.6627H0ZM3.42625 25.6997C4.33169 25.6275 5.1689 25.6446 5.96805 25.4792C7.28685 25.205 8.0965 24.121 8.15555 22.7445C8.22248 21.1856 7.54274 20.0859 6.2095 19.6253C5.308 19.313 4.38156 19.3445 3.42625 19.4141V25.6997Z"
        fill="#1D1F21"
      />
      <path
        d="M57.887 16.2542H61.2503C62.9942 20.3707 64.7369 24.4872 66.5084 28.6693H62.8013C62.5087 27.9843 62.2043 27.2718 61.8998 26.5605H57.1417C56.8477 27.2744 56.5603 27.9725 56.2743 28.668H52.6328C54.3991 24.4938 56.1339 20.397 57.887 16.2542ZM59.6139 20.5636H59.4709C59.051 21.6187 58.631 22.6724 58.1914 23.7786H60.8776C60.4459 22.6803 60.0299 21.6226 59.6139 20.5636Z"
        fill="#1D1F21"
      />
      <path
        d="M88.012 16.3486H97.8655V19.3483H91.4776V21.4033H97.2737V24.3073H91.454V28.6587H88.012V16.3486Z"
        fill="#1D1F21"
      />
      <path
        d="M41.2888 28.6548V16.3591H44.7033V25.6393H50.6385V28.6561H41.2888V28.6548Z"
        fill="#1D1F21"
      />
      <path
        d="M32.9183 25.65H38.8759V28.6261H29.4934V16.3226H32.9183V25.65Z"
        fill="#1D1F21"
      />
    </g>
    <defs>
      <clipPath id="clip0_3808_16269">
        <rect
          width="191.977"
          height="24.031"
          fill="white"
          transform="translate(0 11)"
        />
      </clipPath>
    </defs>
  </svg>
)
